import { EmbeddedSessionLocationEnum } from "./Form";

export enum PatientStatus {
  Incapacitated = "Incapacitated",
  Minor = "Minor",
  Deceased = "Deceased",
}

export enum Gender {
  Male = "Male",
  Female = "Female",
  Other = "Other",
  Unknown = "Unknown",
}

export enum Country {
  UnitedStates = "US",
  Canada = "CA",
}

export enum IdentifierType {
  SSN = "ssn",
  DriversLicense = "driverslicense",
  Passport = "passport",
  PharmacyCard = "pharmacycard",
  GovernmentId = "governmentid",
  InsuranceBenefitsCard = "insurancebenefitscard",
  ProofOfRelationship = "proofofrelationship",
}

export enum PhoneType {
  Home = "home",
  Work = "work",
  Mobile = "mobile",
}

export enum AddressType {
  Home = "Home",
  Work = "Work",
  Postal = "Postal",
}

export enum ContactType {
  Relative = "Relative",
  Parent = "Parent",
  Guardian = "Guardian",
  PowerOfAttorney = "PowerOfAttorney",
  ExecutorOfEstate = "ExecutorOfEstate",
  NextOfKin = "NextOfKin",
  Spouse = "Spouse",
  Other = "Other",
  Unknown = "Unknown",
}

export enum AuthorizationStatusType {
  Pending = "Pending",
  PendingReview = "PendingReview",
  Accepted = "Accepted",
  Rejected = "Rejected",
  Revoked = "Revoked",
  Archived = "Archived",
}

export enum ActionType {
  AuthorizationAccepted = "AuthorizationAccepted",
  AuthorizationRejected = "AuthorizationRejected",
  AuthorizationFailed = "AuthorizationFailed",
  DocumentUploaded = "DocumentUploaded",
  IdentityDocumentDeniedFraud = "IdentityDocumentDeniedFraud",
  IdentityVerificationSimilarityMatchValidityTrue = "IdentityVerificationSimilarityMatchValidityTrue",
  PatientProfileReviewed = "PatientProfileReviewed",
  SdmProfileReviewed = "SdmProfileReviewed",
  Login = "Login",
  RetrievalCreated = "RetrievalCreated",
}

export enum CopyMessageType {
  MyData = `By authorizing, you allow \${appName} to make read or write updates to your health data on Marble.`,
  Retrieval = `By authorizing below, you authorize Marble to access your health data from the Provider(s) defined. With your authorization Marble will collect the health data on your behalf and share it with \${appName}.`,
  PatientPortal = `By logging into your Patient Portal and granting access, you authorize Marble to access your health data from the Provider(s) defined. With your authorization Marble will collect the health data on your behalf and share it with \${appName}.`,
  ESignature = `By providing your e-signature, you acknowledge that you have reviewed and agree to the authorization form and you authorize Marble to access your records from the listed Provider(s). Marble will use your authorization to collect the records on your behalf and share them with \${appName}.`,
}

export enum ProtectedRouteType {
  Lives = "~/lives/",
  Data = "~/data/",
  Retrievals = "~/retrievals/",
}

export enum ActionButtonMessageType {
  Authorize = "Accept",
  AuthorizeSelected = "Accept selected",
  AuthorizeAll = "Accept all",
  AuthorizePatientPortal = "Accept via Patient Portal",
  ReviewPdfAuthorization = "Review authorization",
  Deny = "Deny",
  DenyAll = "Deny all",
  SignHere = "Sign here",
  RetryAccepting = "Retry Accepting",
  SkipForNow = "Skip for now",
  Continue = "Continue",
}

export enum IdentityTransactionStatus {
  Started = "Started",
  Created = "Created",
  Pending = "Pending",
  Success = "Success",
  Failed = "Failed",
}
export enum IdentityVerificationStatus {
  Verified = "Verified",
  NotVerified = "NotVerified",
}

export enum IdentityDocumentStatus {
  Approved = "Approved",
  DeniedFraud = "DeniedFraud",
  DeniedUnsupportedIdType = "DeniedUnsupportedIdType",
  DeniedUnsupportedIdCountry = "DeniedUnsupportedIdCountry",
  ErrorNotReadableId = "ErrorNotReadableId",
  NoIdUploaded = "NoIdUploaded",
  FailedUnknown = "FailedUnknown",
}

export enum DocumentRejectReason {
  PhotocopyBlackWhite = "PHOTOCOPY_BLACK_WHITE",
  PhotocopyColor = "PHOTOCOPY_COLOR",
  DigitalCopy = "DIGITAL_COPY",
  NotReadableDocument = "NOT_READABLE_DOCUMENT",
  Blurred = "BLURRED",
  BadQuality = "BAD_QUALITY",
  MissingPartDocument = "MISSING_PART_DOCUMENT",
  HiddenPartDocument = "HIDDEN_PART_DOCUMENT",
  DamagedDocument = "DAMAGED_DOCUMENT",
  Glare = "GLARE",
  MissingMandatoryDatapoints = "MISSING_MANDATORY_DATAPOINTS",
  NoDocument = "NO_DOCUMENT",
  SampleDocument = "SAMPLE_DOCUMENT",
  MissingBack = "MISSING_BACK",
  WrongDocumentPage = "WRONG_DOCUMENT_PAGE",
  MissingSignature = "MISSING_SIGNATURE",
  CameraBlackWhite = "CAMERA_BLACK_WHITE",
  DifferentPersonsShown = "DIFFERENT_PERSONS_SHOWN",
  InvalidWatermark = "INVALID_WATERMARK",
  MissingFront = "MISSING_FRONT",
  ManualRejection = "MANUAL_REJECTION",
}

export enum IdentityRejectReason {
  SimilarityNoMatch = "NO_MATCH",
  SelfieCroppedFromID = "SELFIE_CROPPED_FROM_ID",
  EntireIdUsedAsSelfie = "ENTIRE_ID_USED_AS_SELFIE",
  MultiplePeople = "MULTIPLE_PEOPLE",
  SelfieIsScreenPaperVideo = "SELFIE_IS_SCREEN_PAPER_VIDEO",
  SelfieManipulated = "SELFIE_MANIPULATED",
  AgeDifferenceTooBig = "AGE_DIFFERENCE_TOO_BIG",
  NoFacePresent = "NO_FACE_PRESENT",
  FaceNotFullyVisible = "FACE_NOT_FULLY_VISIBLE",
  SelfieBadQuality = "BAD_QUALITY",
  BlackAndWhite = "BLACK_AND_WHITE",
  LivenessFailed = "LIVENESS_FAILED",
}

export enum IdentityVerificationSimilarity {
  SimilarityMatch = "MATCH",
  SimilarityNoMatch = "NO_MATCH",
  SimilarityNotPossible = "NOT_POSSIBLE",
}

export enum DocumentRejectReasonMessage {
  DeniedFraud = "Your ID document could not be verified.",
  DeniedUnsupportedIdType = "Your ID document type is not supported. Please use a valid government issued photo ID.",
  DeniedUnsupportedIdCountry = "Your ID document country is not supported. Please use a valid government issued photo ID.",
  NoIdUploaded = "Your ID document was not provided. Please use a valid government issued photo ID.",
  FailedUnknown = "Your ID document could not be verified.",
  PhotocopyBlackWhite = "Your ID document is recognized as a photocopy. Please use the original document.",
  PhotocopyColor = "Your ID document is recognized as a photocopy. Please use the original document.",
  DigitalCopy = "Your ID document is recognized as a photocopy. Please use the original document.",
  Blurred = "Your ID document is not readable due to blurry photo capture. Please use your smartphone and focus on the document when taking the picture.",
  BadQuality = "Your ID document is not readable due to poor quality photo capture. Please use your smartphone and focus on the document when taking the picture.",
  MissingPartDocument = "Your ID document is not readable due to a missing part of the document. Please ensure you capture the full document.",
  HiddenPartDocument = "Your ID document is not readable due to a hidden part of the document. Please ensure you capture the full document.",
  DamagedDocument = "Your ID document is not readable due to damage on the document. Please use a document that is clearly visible and not damaged.",
  Glare = "Your ID document is not readable due to a glare on the document photo. Please ensure all the contents of the document are visible when taking the picture.",
  MissingMandatoryDatapoints = "Your ID document is not readable due to missing required data points on the document. Please ensure you capture the full document.",
  NoDocument = "Your ID document is not visible. Please ensure you capture the full document.",
  SampleDocument = "Your ID document is recognized as a sample document. Please use your original document.",
  MissingBack = "Your ID document is missing the back side. Please include the back side when asked to take a picture of the back.",
  WrongDocumentPage = "Your ID document includes a wrong document page. Please capture the correct document page.",
  MissingSignature = "Your ID document is missing a signature. Please ensure you have signed the document and capture the full document.",
  CameraBlackWhite = "Your ID document photo is black and white. Please take the picture in full colour.",
  DifferentPersonsShown = "Multiple ID documents were captured in one image. Please ensure you capture only one, full document.",
  InvalidWatermark = "Your ID document has an invalid watermark. Please use the original document.",
  MissingFront = "Your ID document is missing the front side. Please include the front side when asked to take a picture of the front.",
  ManualRejection = "Your ID document could not be verified.",
}

export enum IdentityRejectReasonMessage {
  SimilarityNoMatch = "Your live selfie photo could not be verified.",
  SelfieCroppedFromID = "Your live selfie photo could not be verified.",
  EntireIdUsedAsSelfie = "Your ID document was used as the live selfie photo. Please take a photo of your face after capturing the document(s).",
  MultiplePeople = "There was more than one person in the live selfie photo. Please ensure only your face is visible in the photo.",
  SelfieIsScreenPaperVideo = "Your live selfie photo could not be verified.",
  SelfieManipulated = "Your live selfie photo could not be verified.",
  AgeDifferenceTooBig = "Your live selfie photo could not be verified.",
  NoFacePresent = "There is no face visible in the live selfie photo. Please ensure your entire face is clearly visible in the photo.",
  FaceNotFullyVisible = "Your face is not fully visible in the live selfie photo. Please ensure your entire face is clearly visible in the photo.",
  SelfieBadQuality = "Your live selfie photo was captured in poor quality. Please use your smartphone and focus on your face when taking the picture.",
  BlackAndWhite = "Your live selfie photo was captured in black and white. Please take the picture in full colour.",
  LivenessFailed = "Your live selfie photo was not captured correctly. Please ensure your entire face is clearly visible in the photo.",
}

export enum RetrievalTypeKindEnum {
  Multiple = "Multiple",
  Single = "Single",
}

export enum CanCreateRetrievalErrorsEnum {
  Duplicate = "DUPLICATE_RETRIEVAL",
}

export enum IdentityRequirement {
  None = "None",
  IdAndIdentity = "IdAndIdentity",
}

export enum AuthorizationTypeEnum {
  PDF = "PDF",
  Checkbox = "Checkbox",
  External = "External",
}

export enum ProtectedResource {
  Authorization = "~/authorizations/",
  Identity = "~/identity/",
  Document = "~/documents/",
  FhirData = "~/data/fhir/r4/",
  // ~/data does not have trailing slash due to use case where
  // there can be an authorization root authorization such as ~/data.read
  Data = "~/data",
  Blob = "~/data/blob/",
  Retrievals = "~/retrievals/",
  Lives = "~/lives/",
}

export enum SignatureType {
  Signature = "Signature",
  Initials = "Initials",
}

export enum PageName {
  CompleteProfilePage = "CompleteProfilePage",
}

export enum EMRErrorType {
  Retriable = "000",
  RetriablePayerNotFound = "010",
  NonRetriable = "001",
}

export enum FileExtension {
  PDF = ".pdf",
  JPEG = ".jpeg",
  JPG = ".jpg",
  PNG = ".png",
  JSON = ".json",
  CSV = ".csv",
  ZIP = ".zip",
  HEIC = ".heic",
  HEIF = ".heif",
  DOC = ".doc",
  DOCX = ".docx",
  RTF = ".rtf",
  TXT = ".txt",
}

export const IdentifierDictionary = {
  [IdentifierType.DriversLicense as string]: "Driver's License",
  [IdentifierType.GovernmentId as string]: "Government ID",
  [IdentifierType.InsuranceBenefitsCard as string]: "Insurance Benefits Card",
  [IdentifierType.Passport as string]: "Passport",
  [IdentifierType.PharmacyCard as string]: "Pharmacy Card",
  [IdentifierType.SSN as string]: "SSN",
};

export enum SortStatusType {
  Pending = "Pending",
  Disabled = "Disabled",
  Accepted = "Accepted",
  Rejected = "Rejected",
}

export enum RequiredDemographics {
  SSN = "SSN",
  Address = "Address",
  PhoneNumber = "PhoneNumber",
  County = "County",
}

export enum AuthorizationRequiredFields {
  SSN = "Life.Identifiers.SSN",
  GivenName = "Life.GivenName",
  FamilyName = "Life.FamilyName",
  Gender = "Life.Gender",
  BirthDate = "Life.BirthDate",
  DeceasedDate = "Life.DeceasedDate",
  Address_City = "Life.Addresses.City",
  Address_State = "Life.Addresses.State",
  Address_PostalCode = "Life.Addresses.PostalCode",
  Address_Country = "Life.Addresses.Country",
  Address_County = "Life.Addresses.County",
  Address_AddressLine1 = "Life.Addresses.AddressLine1",
  Address_AddressLine2 = "Life.Addresses.AddressLine2",
}

export enum ErrorCode {
  InvalidSession = "INVALID_SESSION",
  SessionCompleted = "SESSION_COMPLETED",
  CreateUpdateDeleteError = "UPDATE_ERROR",
}

export enum Auth0Errors {
  InvalidCode = "Wrong email or verification code.",
  ExpiredCode = "The verification code has expired. Please try to login again.",
  Blocked = "blocked",
  UnknownError = "An error occurred while processing your request",
}
export enum VerifyCodeFeedback {
  InvalidCode = "Please enter a valid code.",
  UserBlocked = "Your account has been blocked. Please check your email for further instructions or contact our support at help@marbleapi.com.",
  UnknownError = "Please try again later or contact our support at help@marbleapi.com.",
}

export enum AuthServiceErrors {
  CreateUserError = "An error occurred while creating a user",
}

export enum DataType {
  Blob,
  FhirR4,
  Dicom,
}

export enum LoginVerificationType {
  Email = "email",
  SMS = "sms",
}

export enum LoginScopeEnum {
  Session = "session",
  Portal = "portal",
}

export enum AppStatus {
  Active = "Active",
  Inactive = "Inactive",
  NonExisting = "NonExisting",
}

export enum DateFormat {
  Standard = "MM/dd/yyyy",
  Short = "MMM do, yyyy",
  Long = "MMMM do, yyyy",
}

export enum SortOrder {
  Ascending = "Ascending",
  Descending = "Descending",
}

export enum FhirResource {
  DocumentReference = "DocumentReference",
}

export enum PhoneNumberChangeErrors {
  PhoneInUse = "Phone number can't be used for MFA because it is already in use",
  VerifyCodeError = "VERIFY_CODE_ERROR",
}
export enum RelationshipType {
  Parent = "Parent",
  Guardian = "Guardian",
  PowerofAttorney = "PowerOfAttorney",
  ExecutorofEstate = "ExecutorOfEstate",
  NextofKin = "NextOfKin",
  Other = "Other",
}

export enum IdentifierSubtype {
  BirthCertificate = "BirthCertificate",
  CourtDocumentAppointingGuardian = "CourtDocumentAppointingGuardian",
  PowerOfAttorneyDocument = "PowerOfAttorneyDocument",
  LastWillAndTestament = "LastWillAndTestament",
  EstateTrusteeAppointmentCertificate = "EstateTrusteeAppointmentCertificate",
  DeathCertificate = "DeathCertificate",
  AffidavitOfNextOfKin = "AffidavitOfNextOfKin",
  MarriageCertificate = "MarriageCertificate",
  Other = "Other",
}

export const ProofOfRelationshipDocumentTypesDictionary: {
  [key: string]: string;
} = {
  [IdentifierType.GovernmentId]: "Government Issued ID",
  [IdentifierSubtype.BirthCertificate]: "Birth Certificate (long form)",
  [IdentifierSubtype.CourtDocumentAppointingGuardian]:
    "Court Document Appointing User as Guardian",
  [IdentifierSubtype.PowerOfAttorneyDocument]:
    "Power of Attorney Document for Personal Care",
  [IdentifierSubtype.EstateTrusteeAppointmentCertificate]:
    "Estate Trustee Appointment Certificate",
  [IdentifierSubtype.AffidavitOfNextOfKin]: "Affidavit of Next of Kin",
  [IdentifierSubtype.DeathCertificate]: "Death Certificate",
  [IdentifierSubtype.MarriageCertificate]: "Marriage Certificate",
  [IdentifierSubtype.LastWillAndTestament]: "Last Will and Testament",
  [IdentifierSubtype.Other]: "Other",
};

export enum DocumentVerificationStatus {
  Pending = "Pending",
  Verified = "Verified",
  Rejected = "Rejected",
}

export const FormLocationNextStep = {
  AfterLogin: "identity",
  AfterProfile: "authorizations",
  AfterProfileWithSdm: "sdm/proofOfRelationship",
  AfterProviderSearch: "confirmation",
  AfterAuthorizations: "confirmation",
  AfterAuthorizationsWithProviderSearch: "providerSearch",
};

export enum FormsDupPositionsEnum {
  BeforeAuth = "BeforeAuth",
  AfterAuth = "AfterAuth",
}
export const FormsDupPositionsMap: {
  [key in EmbeddedSessionLocationEnum]: FormsDupPositionsEnum;
} = {
  [EmbeddedSessionLocationEnum.AfterLogin]: FormsDupPositionsEnum.BeforeAuth,
  [EmbeddedSessionLocationEnum.AfterProfile]: FormsDupPositionsEnum.BeforeAuth,
  [EmbeddedSessionLocationEnum.AfterProviderSearch]:
    FormsDupPositionsEnum.AfterAuth,
  [EmbeddedSessionLocationEnum.AfterAuthorizations]:
    FormsDupPositionsEnum.AfterAuth,
};
